import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
// import { AppConfig } from '../app.config';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { APIResponse } from '../_types/api-responses.types';
import { getAgentsOfPartnerRequest, Partner } from '../_types/partner.type';
import { Category, Product, SubCategory } from '../_types/product.types';

@Injectable({
  providedIn: 'root',
})
export class AgentService {
  _headers: any;

  httpOptions: any;

  _headersWithToken: any;

  _baseURL: string;

  _CommunicatorbaseURL: string;

  _user: any = {};

  deviceInfo: any;

  _headersOTP: any;

  _FeebaseURL: any;

  constructor(
    private httpClient: HttpClient,
    private deviceService: DeviceDetectorService
  ) {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const devicedetail: any = {
      platform: 'Website',
      browser: this.deviceInfo.browser,
      browserVersion: this.deviceInfo.browser_version,
      osVersion: this.deviceInfo.os_version,
      deviceId: this.deviceInfo.device + this.deviceInfo.deviceType,
      appVersion: '',
      ipAddress: '',
      macAddress: '',
    };
    this._headers = new HttpHeaders()
      .set('content-type', 'application/json')
      .set('User_Agent', JSON.stringify(devicedetail));
    this._headersOTP = new HttpHeaders()
      .set('content-type', 'application/json')
      .set('data-hash', 'test')
      .set('device-id', 'test')
      .set('User_Agent', JSON.stringify(devicedetail));

    this._baseURL = environment.USERAPIENDPOINT;
    this._FeebaseURL = environment.FEEAPIENDPOINT;
    this._CommunicatorbaseURL = environment.COMMUNICATORAPIURL;

    if (this.isUserLoggedIn()) {
      this.getCurrentUser();

      this._headersWithToken = new HttpHeaders()
        .set('content-type', 'application/json')
        .set('Access-Token', this._user.token)
        .set('User_Agent', JSON.stringify(devicedetail));
    }
  }

  get headersWithToken(): HttpHeaders {
    return this._headers.set('Access-Token', this.getCurrentUser().token);
  }

  isUserLoggedIn(): boolean {
    const data = localStorage.getItem('user');
    if (data != null) {
      return true;
    }
    return false;
  }

  getCurrentUser(): any {
    const data: any = localStorage.getItem('user');
    if (data != null) {
      this._user = JSON.parse(data);
    }
    return this._user;
  }

  signUp(obj: any): Observable<any> {
    return this.httpClient.post(`${this._baseURL}partner/signup`, obj, {
      headers: this._headers,
    });
  }

  _getCommissionProfile(obj: any): Observable<any> {
    return this.httpClient.post(`${this._FeebaseURL}get/profiles`, obj, {
      headers: this.headersWithToken,
    });
  }

  _getAgentList(obj: any): Observable<any> {
    return this.httpClient.post(`${this._baseURL}admin/get/agents`, obj, {
      headers: this.headersWithToken,
    });
  }

  _addCommission(obj: any): Observable<any> {
    return this.httpClient.post(
      `${this._FeebaseURL}add/agent-commission`,
      obj,
      { headers: this.headersWithToken }
    );
  }

  _deleteAgent(obj: any): Observable<any> {
    return this.httpClient.put(`${this._baseURL}partner/delete/agent`, obj, {
      headers: this.headersWithToken,
    });
  }

  _getFeeCategory(
    obj: any
  ): Observable<APIResponse<{ categoryList: Category[] }>> {
    return this.httpClient.post<APIResponse<{ categoryList: Category[] }>>(
      `${this._FeebaseURL}get/category`,
      obj,
      {
        headers: this.headersWithToken,
      }
    );
  }

  _getFeeSubCategory(
    obj: any,
    activeOnly: boolean = false
  ): Observable<APIResponse<{ subCategoryList: SubCategory[] }>> {
    return this.httpClient.post<
      APIResponse<{ subCategoryList: SubCategory[] }>
    >(
      `${this._FeebaseURL}get/sub-category`,
      { ...obj, activeOnly },
      {
        headers: this.headersWithToken,
      }
    );
  }

  _getDetails(obj: any): Observable<any> {
    return this.httpClient.post(`${this._baseURL}partner/details`, obj, {
      headers: this.headersWithToken,
    });
  }

  _updateProfile(obj: any): Observable<any> {
    return this.httpClient.put(`${this._baseURL}partner/update`, obj, {
      headers: this.headersWithToken,
    });
  }

  _getAgentCategory(request: {
    agentId: string;
  }): Observable<APIResponse<{ categoryList: Category[] }>> {
    return this.httpClient.post<APIResponse<{ categoryList: Category[] }>>(
      `${this._FeebaseURL}get/agent/category`,
      request,
      {
        headers: this.headersWithToken,
      }
    );
  }

  _getAllProposalProduct(
    obj: any,
    activeOnly: boolean = false
  ): Observable<APIResponse<{ productList: Product[] }>> {
    return this.httpClient.post<APIResponse<{ productList: Product[] }>>(
      `${this._FeebaseURL}get/product`,
      { ...obj, activeOnly },
      {
        headers: this.headersWithToken,
      }
    );
  }

  _getCategorytAgentList(obj: any): Observable<any> {
    return this.httpClient.post(`${this._FeebaseURL}get/category/agents`, obj, {
      headers: this.headersWithToken,
    });
  }

  _getCommission(obj: any): Observable<any> {
    return this.httpClient.post(`${this._FeebaseURL}get/commission`, obj, {
      headers: this.headersWithToken,
    });
  }

  getAgentsOfPartner(
    obj: getAgentsOfPartnerRequest
  ): Observable<APIResponse<{ agentsList: Partner[] }>> {
    return this.httpClient.post<APIResponse<{ agentsList: Partner[] }>>(
      `${this._baseURL}partner/get/partner/agents`,
      obj,
      {
        headers: this.headersWithToken,
      }
    );
  }
}
